import React, { Component } from 'react'
import { sessionItemByKeys, strVal } from '../../../../../../modules/Utils'
import { get } from 'lodash'
import { Button } from 'antd'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import InfoTooltip from '../../../../../../elements/InfoTooltip'

class OrderLineList extends Component {
  render () {
    const {
      url,
      onShowOrderLine,
      fetch,
      fetching,
      linesList,
      hide,
      type,
      actions,
      onShowInvoice,
    } = this.props
    let columns = [
      {
        Header: 'Line ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Delivery Line  ID',
        accessor: 'deliveryOrderLines._id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Item',
        accessor: 'no',
        Cell: ({ value, original }) => (
          <a onClick={() => onShowOrderLine(original, 'edit')}>{value}</a>
        ),
      },
      {
        Header: 'Product',
        accessor: 'product._id',
        width: 350,
        Cell: ({ value, original }) =>
          get(original, 'product.name') ||
          sessionItemByKeys(`products_${url}_dropdown`, value, '_id', 'name'),
      },
      {
        Header: 'Description',
        accessor: 'description',
      },
      {
        Header: 'Invoiced',
        accessor: 'invoiced',
      },
      {
        Header: 'Qty',
        accessor: 'unit',
      },
      {
        Header: 'UoM',
        accessor: 'uom.code',
      },
      {
        Header: 'Unit Price',
        accessor: 'rate',
      },
      {
        Header: 'Tax Type',
        accessor: 'tax.type',
        Cell: ({ value }) => strVal({ value }, 'value').toUpperCase(),
      },
      {
        Header: 'Tax Percentage',
        accessor: 'tax.percentage',
      },
      {
        Header: 'Delivery',
        accessor: 'recurring.delivery',
        hideable: true,
        hideDefault: true,
        Cell: ({ value }) => value && (value === true ? 'Yes' : 'No'),
      },
      {
        Header: 'Recurring',
        accessor: 'recurring.value',
        Cell: ({ value }) => (value && value === true ? 'Yes' : 'No'),
      },
      {
        Header: 'Frequency',
        accessor: 'recurring.frequency',
        hideable: true,
        hideDefault: true,
        Cell: ({ value }) => value && value.toUpperCase(),
      },
      {
        Header: (
          <InfoTooltip
            value={'Period End Day'}
            title={'Billing period end day for each invoice.'}
          />
        ),
        accessor: 'recurring.day',
        hideable: true,
        hideDefault: true,
        Cell: ({ value }) => value && value.toUpperCase(),
      },
    ]
    if (type === 'view') columns = columns.filter(c => c.accessor !== 'operation')
    const isUpdatable = type === 'new' || !!actions.find(a => a.key === 'update')

    return (
      <CustomTable
        fetch={fetch}
        CreateButton={() => (
          <Button
            style={{ float: 'left', marginRight: 10 }}
            size={'small'}
            onClick={onShowOrderLine}
            type={'primary'}
            icon={'plus'}>
            Add Line
          </Button>
        )}
        ExtraButtons={() => (
          <Button
            style={{ marginLeft: 10 }}
            type={'dashed'}
            size={'small'}
            icon={'plus'}
            disabled={isUpdatable}
            onClick={onShowInvoice}>
            Invoice All
          </Button>
        )}
        loading={fetching}
        columns={columns}
        hide={hide}
        data={linesList}
        size="small"
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        style={{ marginTop: 10 }}
      />
    )
  }
}

OrderLineList.propTypes = {}
OrderLineList.defaultProps = {
  hide: { create: true },
}

export default OrderLineList
